<template><div></div></template>

<script setup lang="ts">
import { onMounted } from "vue";

onMounted(() => {
  const zoomableImages = document.querySelectorAll("figure");
  zoomableImages.forEach((zoomableImage) => {
    zoomableImage.setAttribute("data-full-width", "false");
    zoomableImage.addEventListener("click", () => {
      if (zoomableImage.getAttribute("data-full-width") === "true") {
        zoomableImage.setAttribute("data-full-width", "false");
      } else {
        zoomableImage.setAttribute("data-full-width", "true");
      }
    });
  });
});
</script>
